module.exports = "/app/main/img/extra-card-v2.9d678416.png";